<script setup lang="ts">
import Modal from '../Modal.vue';
import { useLocale } from '../../composables/useLocale';

const { t } = useLocale();

type Props = {
  name: string;
  isLoading: boolean;
  onConfirm?: () => void;
  onReject?: () => void;
};

defineProps<Props>();
</script>

<template>
  <Modal
    :name="name"
    :title="t('lcp.remove_group_member')"
    :show-close-btn="true"
    :loading="isLoading"
    :action="onConfirm"
    :action-label="t('lcp.remove')"
    actionColor="error"
    :cancel-action="onReject"
  >
    <p>
      {{ t('lcp.remove_group_member_confirmation') }}
    </p>
  </Modal>
</template>
